import PageContext from "global_state/context/PageContext"
import { useContext } from "react"

import SCSS from 'assets/scss/CreateOnlineAccount.module.scss'
import FormSCSS from 'assets/scss/Form.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'

import { PageType } from "types/PageI"

import content from 'languages/EmailNotFound.json'
import Title from "components/Title"

interface EmailNotFoundProps {
    page?: PageType
}
function EmailNotFound(props: EmailNotFoundProps) {
    const {page, dispatchPage}  = useContext(PageContext)
    let language = page.settings.language

    const handleSubmit = (event) => {
        event.preventDefault()
        // console.log(event);

        // TODO: render based on the props - create_online_account or forgotten password
        if ('page' in props) {
            dispatchPage({type: "render", payload: {page: props.page}})
            return 
        }

        dispatchPage({type: "render", payload: {page: PageType.create_online_account}})
        

    }

    return (
        <div className={[SCSS.email_not_found, FormSCSS.form_wrapper].join(" ")}>   
            <Title back_arrow={false} title={content[language].title}/>
            <form
                className={FormSCSS.form} 
                onSubmit={(event) => {handleSubmit(event)}}>
                
                <div className={SCSS.info_text}>{content[language].text}</div>
                
                <button 
                    className={[AppSCSS.button, AppSCSS.red].join(" ")}
                    type="submit">
                    {content[language].button_submit}
                </button>

            </form>
        </div>
    )
}

export default EmailNotFound